import { render, staticRenderFns } from "./PerDelSupplier.vue?vue&type=template&id=516b20ff&scoped=true&"
import script from "./PerDelSupplier.vue?vue&type=script&lang=js&"
export * from "./PerDelSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516b20ff",
  null
  
)

export default component.exports